export enum Language {
  ENGLISH = 'en',
  JAPANESES = 'ja',
}
export enum NOTIFICATION_TYPES {
  NOTHING = 1,
  OPEN_LINK = 2,
  WELCOME = 3,
}
export const YEN_RATE = 125
export enum HTTP_CODE {
  BAD_REQUEST = 400,
  SUCCESS = 200,
  CREATE_NEW = 201,
  INTERNAL_SERVER_ERROR = 500,
}

export enum USER_ROLE {
  NORMAL_USER = 'NORMAL_USER',
  BRANCH_USER = 'ENTERPRISE_USER',
  BRANCH_EMPLOYEE = 'ENTERPRISE_MEMBER',
}

export enum USER_STATUS {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  UN_VERIFY = 'UN_VERIFY',
}

export const ALL_KEY = 0

export const MAX_INDIVIDUAL_UPLOAD_ITEMS = 10
export const MAX_SUBSCRIPTION_UPLOAD_ITEMS = 50
export const MAX_ENTERPRISE_UPLOAD_ITEMS = 100
export const MAX_INDIVIDUAL_FILE_SIZE = 10485760 //10Mb
export const MAX_ENTERPRISE_FILE_SIZE = 10485760 * 2 //20Mb
export const MAX_COMBOBOX_LOAD_ITEMS = 50
export const Subscription800 = 12
export enum PAYMENT_METHOD {
  VISA = 'VISA',
  BANK = 'BANK',
  CREDIT = 'CREDIT',
  STRIPE = 'STRIPE',
}
export const APP_TERM_AND_CONDITION_LINK = process.env.REACT_APP_WEBSITE + '/term-of-service'

export const POSTCODE_REGEX = /^[a-zA-Z0-9-\s]{3,10}$/
export const PHONE_REGEX = /^[\d\s()+-]*$/

export const PHOTO_ENHANCEMENT_SERVICE_ID = 1
export const DATE_ONLY_FORMAT = 'MM/DD'

export const DATE_FORMAT = 'YYYY-MM-DD'
export const HARDCODE_USER_ADMIN_FOR_TEST = 'hashimoto@a-leadsholdings.com'
